import React from 'react';
import './Terms.css';

const Terms: React.FC = () => {
  return (
    <div className="legal-container">
      <h1>Terms & Conditions</h1>
      <p><strong>Effective Date:</strong> April 1, 2025</p>
      <p>
        Welcome to www.smartrainmakers.com (the “Platform” or “Website” or “Service”). The Website is owned and operated by Smart Rainmakers ("Smart Rainmakers", “we”, “us”, or “our”), a community-based platform built to connect members—whether givers or receivers—through a donation-based crowdfunding ecosystem.
      </p>
      <p>
        By accessing or using this platform, or website or any affiliated services, you (“User”, “Member”, “Affiliate”, “Referrer”, “Participant”, “Upliner”, “Sponsor”, or “you”) agree to be legally bound by these Terms and Conditions (“Terms”), as well as our Privacy Policy. If you do not accept these Terms, you must not access or use our Website or Services.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using www.smartrainmakers.com (the "Website"), you agree to be bound by these Terms and Conditions ("Terms") and our Privacy Policy. If you do not agree to these Terms, do not use the Website.
      </p>

      <h2>2. Access To The Platform</h2>
      <p>
        Smart Rainmakers strives to maintain 24/7 Website availability, but does not guarantee uninterrupted access. Downtime may occur due to maintenance, system upgrades, or unforeseen issues, such as smart contract upgrades or blockchain challenges. We reserve the right to limit or restrict access—temporarily or permanently—without notice or liability.
      </p>

      <h2>3. User Conduct</h2>
      <p>
        You agree to use the Website lawfully and in accordance with these Terms. You grant Smart Rainmakers a non-exclusive, royalty-free, worldwide license to use, reproduce, modify, and distribute any content you submit. You are solely responsible for ensuring you have the right to upload any third-party content.
      </p>

      <h2>4. Privacy</h2>
      <p>
        Please review the platform Privacy Policy, which explains how we collect, use, and protect your personal data. By using the Service, you consent to the practices described in the Privacy Policy and confirm that all data you provide is accurate and current.
      </p>

      <h2>5. Registration and Membership</h2>
      <p>
        Registration is optional, but certain features may require it. When you register (“JOIN”), you agree to provide accurate, current, and complete information. Failure to do so may result in suspension or termination of your account.
      </p>
      <p>
        Joining is free. However, becoming an “Active Member” may involve making voluntary donations. If making a financial contribution, you must provide accurate payment information and confirm that:
      </p>
      <ul>
        <li>You are authorized to use the payment method.</li>
        <li>All submitted information is accurate and complete.</li>
        <li>Your data may be shared with third-party services for referral, donation tracking, or program participation, as outlined in our Privacy Policy.</li>
      </ul>

      <h2>6. Age Restrictions</h2>
      <p>
        This platform is not intended for users under 18. By using the smart rainmakers website, you confirm you are at least 18 years old. Any underage users will be removed, and we encourage reporting of suspected underage use.
      </p>

      <h2>7. Termination</h2>
      <p>
        Smart Rainmakers may suspend or terminate your access at any time, with or without notice, if you breach these Terms. Upon termination, your rights to use the Website and Services will cease immediately. You agree to indemnify Smart Rainmakers against any claims, liabilities, or legal costs resulting from your use of the Service.
      </p>
      <p><strong>Disclaimer:</strong> We do not guarantee any specific results or offer warranties regarding crowdfunding outcomes for any particular purpose.</p>

      <h2>8. Disclaimer</h2>
      <p>
        Smart Rainmakers does not guarantee crowdfunding success for any specific purpose.
      </p>

      <h2>9. User Responsibilities</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Copy, duplicate, or sell Website content without written consent.</li>
        <li>Alter or misrepresent our content.</li>
        <li>Violate intellectual property rights.</li>
      </ul>

      <h2>10. Changes to Terms</h2>
      <p>
        These Terms may be updated at any time. Continued use of the Service means you accept any revised Terms.
      </p>

      <h2>11. Contact</h2>
      <p>
        For questions or reports, contact <a href="mailto:support@smartrainmakers.com">support@smartrainmakers.com</a> or visit <a href="https://www.smartrainmakers.com" target="_blank" rel="noopener noreferrer">https://www.smartrainmakers.com</a>.
      </p>
    </div>
  );
};

export default Terms;
